import React from 'react'
import BrandPrinterSetup from '../BrandPrinterSetup'

const EpSearch = () => {
  return (
    <>
      <BrandPrinterSetup 
              brand="EPSON" 
              image="https://support-printers.netlify.app/img/Epson-Logo.png" 
            />
    </>
  )
}

export default EpSearch
